export const authRoutes = {
  signUp: 'auth/signup' as const,
  changePassword: 'auth/external-change-password' as const,
  token: 'auth/signin' as const,
  refreshToken: 'auth/refresh-token' as const,
  signOut: 'auth/global-sign-out' as const,
  sso: 'auth/sso' as const,
} as const;
